module.exports = __webpack_public_path__ + "static/media/firefly.863ef434.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/firefly.webp
// module id = 467
// module chunks = 0